import styled from 'styled-components';

export const Table = styled.div`
  font-size: 14px;
  empty-cells: show;
  overflow: hidden;
  min-height: fit-content;
  height: 100%;

  @media only screen and (max-width: 768px) {
    width: auto;
  }

  @media print {
    font-size: 12px;
  }
`;
